import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppActions, AppActionTypes } from './actions';
import { TotalNitrogenLegalNorm, TotalNitrogenLegalNormState } from '../shared/models';

export const totalNitrogenLegalNormAdapter: EntityAdapter<TotalNitrogenLegalNorm> = createEntityAdapter<TotalNitrogenLegalNorm>();
export const initialTotalNitrogenLegalNormState: TotalNitrogenLegalNormState = totalNitrogenLegalNormAdapter.getInitialState({});

export function totalNitrogenLegalNormReducer(state = initialTotalNitrogenLegalNormState, action: AppActions): TotalNitrogenLegalNormState {
  switch (action.type) {
    case AppActionTypes.LoadTotalNitrogenLegalNormsSuccess: {
      const removedState = totalNitrogenLegalNormAdapter.removeAll(state);
      return totalNitrogenLegalNormAdapter.upsertMany(action.totalNitrogenLegalNorms, removedState);
    }

    case AppActionTypes.UpsertTotalNitrogenLegalNormSuccess: {
      return totalNitrogenLegalNormAdapter.upsertOne(action.totalNitrogenLegalNorm, state);
    }

    case AppActionTypes.DeleteTotalNitrogenLegalNormSuccess: {
      return totalNitrogenLegalNormAdapter.removeOne(action.totalNitrogenLegalNorm.id, state);
    }

    default: {
      return state;
    }
  }
}
